import { useContext } from 'react'

import { Form } from 'components/Form'
import { AddEditPageContext } from 'features/inventory/page/contexts/AddEditPageContext'
import { CommonForm } from './CommonForm'
import { useUpdatePage } from './hooks/useUpdatePage'
import { EditSchema, editSchema, editSchemaDefault } from './schemas/editSchema'

export const GeneralFormEdit = (): JSX.Element => {
  const { formId, loading, page, setTouched, setValid } = useContext(AddEditPageContext)
  const { errors: apiErrors, updatePage } = useUpdatePage()

  if (page === undefined) {
    throw new Error('Page should be available for edit')
  }

  return (
    <Form<EditSchema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={updatePage}
      onTouched={setTouched}
      onValid={setValid}
      schema={editSchema}
      schemaDefaults={editSchemaDefault(page)}
    >
      {() => <CommonForm variant='edit' />}
    </Form>
  )
}
